<template>
    <p class="flex items-center gap-3">
        <Spinner v-if="counting" class="size-4" />
        <Check v-else class="size-4" />

        <span v-if="counting">
            Redirecting in
            <NumberFlow :value="timeLeft" class="" />
            seconds
        </span>
        <span v-else>Redirecting</span>
    </p>
</template>

<script lang="ts" setup>
import { Check } from 'lucide-vue-next'
import { onMounted, ref } from 'vue'
import NumberFlow from '@number-flow/vue'
import { Spinner } from '@/components/core/spinners'

interface Props {
    destinationUrl: string
    time: number
    redirect: boolean
}

const props = withDefaults(defineProps<Props>(), {
    time: 1000,
    redirect: true,
})

const timeLeft = ref(props.time)
const counting = ref(false)

const startCountdown = () => {
    counting.value = true
    const timer = setInterval(() => {
        timeLeft.value -= 1
        if (timeLeft.value <= 0) {
            clearInterval(timer)
            counting.value = false
            if (props.redirect) {
                window.location.replace(props.destinationUrl)
            }
        }
    }, 1000)
}

onMounted(() => {
    startCountdown()
})
</script>
